import React, {useEffect} from 'react';
import CroppingImage from '../../../components/croppingImage';
import {useDispatch, useSelector} from 'react-redux';
import {RootState} from '../../../store/redux';
import {useNavigate, useParams} from 'react-router-dom';
import {
  addingCropedImage,
  clearAllData,
  clearImage,
} from '../../../store/redux/imageCropping';

const ChatFormAddImage = () => {
  const {guid} = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const {imageFile} = useSelector((state: RootState) => state.imageCropedit);

  useEffect(() => {
    if (!imageFile) {
      navigate(-1);
    }
    window.onpopstate = _ => {
      dispatch(clearAllData());
    };
  }, []);

  return (
    <CroppingImage
      imageFile={imageFile}
      addingCropedImageDispatcher={file => dispatch(addingCropedImage(file))}
      clearImageDispatcher={() => dispatch(clearImage())}
      navigateControll={() => navigate(`/chat-form/${guid}`)}
    />
  );
};

export default ChatFormAddImage;
